export default "__VITE_ASSET__hJ1OfxpGBPbIkJSwAe8AEQ__"